import './Footer.scss';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="footer-custom">
      <Container className="footer-content">
        © {new Date().getFullYear()} Válicka Kupa
      </Container>
    </footer>
  );
};

export default Footer;